import { useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Container,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuService from "../../components/Menu/menuService";

const FAQ = () => {
  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("faq");
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{
        backgroundColor: "white",
        marginTop: "30px",
        marginBottom: "100px",
        width: "100%",
      }}
    >
      <Box sx={{ marginBottom: "30px" }}>
        <Typography variant="h1">FAQ (Frequently Asked Questions)</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">How does Collecticos work?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Collecticos is a platform for football shirt collectors, built by
              collectors, to upload and showcase their collections (f.e. through
              showing your shirts' Top10), connect with other collectors, and
              explore rare and unique shirts. Collectors have the value of all
              their shirts and their entire collection calculated through our
              AI-powered value calculator, which tracks its value over time,
              providing stock market-style insights. Additionally, expert
              collectors on the platform can authenticate your shirts, verifying
              match-worn pieces or rare editions, which can further increase
              their value.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              Can I buy or sell shirts on Collecticos?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes, collectors can privately negotiate and make offers on shirts.
              While Collecticos provides the platform for these interactions, we
              are not a legal party in any transaction. Payments, negotiations,
              and authenticity verification are solely handled between
              collectors.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Is Collecticos free to use?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes, Collecticos is free for all users. However, for those looking
              to enhance their experience, we offer a VIP Collector membership
              (€5 per month). This unlocks premium features, including advanced
              value tracking for your shirts, detailed collection stats, the
              ability to make your shirts or entire collection private, and much
              more.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              How can I contact another collector?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              You can use the built-in messaging feature to communicate with
              other users. Simply visit their profile and send a message.
              Additionally, you can join discussions in our public community,
              where collectors share insights, stories and opinions.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              Does Collecticos verify the authenticity of shirts?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Shirt authentication on Collecticos is peer-to-peer, meaning other
              collectors — true experts — help verify your shirts. Whether it’s
              a match-worn piece or a rare edition, fellow enthusiasts can
              assess and confirm authenticity through the platform.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
};

export default FAQ;
